// removed by extract-text-webpack-plugin
module.exports = {"root":"StripePaymentAddress-module__root__2pTw2","paymentAddressField":"StripePaymentAddress-module__paymentAddressField__50KzM","formRow":"StripePaymentAddress-module__formRow__1zYS_","field":"StripePaymentAddress-module__field__2BC13"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StripePaymentAddress/StripePaymentAddress.module.css
// module id = 2119
// module chunks = 0